export default __webpack_public_path__ + "static/media/konk.a48f671b.png";